import React, { CSSProperties } from 'react';
import styles from './LoadingDotAnimation.module.css'; // Import the CSS module

interface LoadingDotAnimationProps {
  sx?: CSSProperties;
}
function LoadingDotAnimation({ sx = {} }: LoadingDotAnimationProps) {
  return (
    <div className={styles.loading_dots} style={sx}>
      <div className={styles.dot}>.</div>
      <div className={styles.dot}>.</div>
      <div className={styles.dot}>.</div>
    </div>
  );
}

export default LoadingDotAnimation;
